export default class BaseLayer {
  constructor(layerId) {
    this.layerId = layerId;
  }

  getCanvasObjects() {
    return [];
  }
}
